import { LEVEL_UP_ANALYTICS_META_CELL } from '../constants';

export const getFlexJustifyFromCellAlign = (align) => {
  switch (align) {
    case 'left':
      return 'flex-start';
    case 'center':
      return 'center';
    case 'right':
      return 'flex-end';
    default:
      return 'center';
  }
};

export const columnToCellMetaMapper = ({
  id,
  uuidType,
  displayName,
  isSubRow = false,
  parentDepth,
  levelsForWhichLineToBeDrawn,
  isParentLastRow,
}) => {
  if (uuidType === 'AGGREGATED_METRICS') {
    return LEVEL_UP_ANALYTICS_META_CELL[uuidType]({ id, displayName });
  }
  if (uuidType === 'PROGRESS_PERCENTAGE') {
    return LEVEL_UP_ANALYTICS_META_CELL[uuidType]({ id, displayName });
  }
  if (isSubRow && ['FUNCTION', 'EMPLOYEE_NAME'].includes(uuidType)) {
    return LEVEL_UP_ANALYTICS_META_CELL.subRow({
      id,
      uuidType,
      displayName,
      isSubRow,
      parentDepth,
      levelsForWhichLineToBeDrawn,
      isParentLastRow,
    });
  }
  return LEVEL_UP_ANALYTICS_META_CELL[uuidType]({ id, displayName });
};
